module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/chapel-suns_access_01-5e3e8d502721098fae660a11ec05bd51.jpg";